// extracted by mini-css-extract-plugin
export default {"productGrid":"jY-z","centerLink":"kY-z","productSection":"lY-z","item":"mY-z","ctaButton":"nY-z"};